import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Components } from '@ionic/core';
import { addIcons } from 'ionicons';
import { fileTrayOutline } from 'ionicons/icons';
import { CloudFunctionsService } from 'src/services/cloudfunctions.service';
import { FirestoreService } from 'src/services/firestore.service';
import { UIService } from 'src/services/ui.service';
import { Transaction } from 'bankapp-types';
import { GlobalsService } from 'src/services/globals.service';

@Component({
    selector: 'app-reconcile-transaction',
    templateUrl: 'reconcile-transaction.component.html',
    styleUrls: ['reconcile-transaction.component.scss']
})
export class ReconcileTransactionComponent {


    @Input() modal: Components.IonModal;

    transaction: Transaction

    investorRecon = []

    existingRecon = 0

    startDate: string

    endDate: string

    matching = false

    loading = false

    results = []

    searchKeys = {
        dealName: "",
        entityId: "",
        entityName: "",
        bankCode: "",
        called: ""
    }

    unfunded = true

    callUrls = []

    indeterminate = false

    allSelected = false

    selected = []

    constructor(
        public firestoreService: FirestoreService,
        private cloud: CloudFunctionsService,
        private ui: UIService,
        private globals: GlobalsService
    ) {
        addIcons({ fileTrayOutline });

        const today = new Date()
        this.startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1, -today.getTimezoneOffset() / 60).toISOString()
        this.endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0, -today.getTimezoneOffset() / 60).toISOString()

        console.log(this.startDate, this.endDate, today.getTimezoneOffset())
    }


    async searchCalls() {
        this.loading = true
        this.matching = true
        if(!this.globals.raisingDealsFlat) {
            const raisingDeals = await this.cloud.callHttpFunction("https://australia-southeast1-investor-admin-centre.cloudfunctions.net/getRaisingDeals", "7c16913f9393cfbd0977c8fbef7d9db1a8de3dd416343bc182db6eb6be9becb1f1ccf25043d2f1a80c0418b059418b98ca2342beeed85755b932ed916d696047")
            this.globals.raisingDealsFlat = raisingDeals.reduce((flat, deal) => {
                return [...flat, ...deal.raises.reduce((fflat, raise) => {
                    return [...fflat, ...raise.entities.map(entity => {
                        return {...entity, dealName: deal.dealName, path: deal.path, updateDate: deal.updateDate, date: raise.date, index: raise.index, unitPrice: raise.unitPrice}
                    })]
                }, [])]
            }, [])
            console.log(raisingDeals, this.globals.raisingDealsFlat)
        }

        this.results = this.globals.raisingDealsFlat.filter(raise => {
            return raise.date >= new Date(this.startDate).getTime() && raise.date <= new Date(this.endDate).getTime() &&
            Object.keys(this.searchKeys).every(key => {
                return !this.searchKeys[key] || raise?.[key]?.toString?.()?.toLowerCase?.()?.includes(this.searchKeys[key]?.toLowerCase())
            }) && (!this.unfunded || (raise.called - raise.received) > 0.01)
        }).sort((a,b) => a.callUrl - b.callUrl)

        this.callUrls = Object.fromEntries([...new Set(this.results.sort((a,b) => a.date - b.date).map(raise => raise.callUrl))].filter(x => x).map((url, index) => [url, index + 1]))

        console.log(this.results)

        this.loading = false
    }

    selectAll(event: CustomEvent) {
        const checked = event.detail.checked
        this.selected = this.results.map(x => checked)
        this.checkSelection()
    }

    checkSelection() {
        this.selected = this.selected.map(x => x)
        const selected = this.selected.filter(x => x)
        this.indeterminate = selected.length > 0 && selected.length < this.results.length
        this.allSelected = selected.length === this.results.length
        const results = this.results.filter((x, i) => this.selected[i])
        this.existingRecon = this.investorRecon.filter(x => results.some(y => y?.entityId === x?.entityId && y?.dealName === x?.dealName && y?.index == x?.index)).reduce((acc, curr) => acc + curr.amount, 0)
    }

    async reconcile() {
        const selectedCalls = this.results.filter((x, i) => this.selected[i])

        if(!selectedCalls.length) return

        if(selectedCalls.length === 1) {

        } else if(selectedCalls.length > 1) {
            await this.ui.presentOKAlert("Combined Transaction", "The reconciled transaction will be split into several transactions after reconciliation")
        }
        
        await this.modal.dismiss(selectedCalls)

    }

    dismissModal() {
        this.modal.dismiss()
    }

}
